/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_oer_information_basics_text24 = /** @type {(inputs: {}) => string} */ () => {
	return `Is your lesson preparation underway and the textbook outdated? OER, or Open Educational Resources on the web, can be a great alternative. Whether it's worksheets, photos, or graphics: Depending on the  license, educators not only can use the materials but also adapt them directly for their class. This video explains exactly how that works.`
};

const fr_oer_information_basics_text24 = /** @type {(inputs: {}) => string} */ () => {
	return `Votre préparation de cours est en cours et le manuel est obsolète ? REL, ou Ressources éducatives libres Sur le web, les ressources pédagogiques peuvent constituer une excellente alternative. Qu'il s'agisse de fiches d'exercices, de photos ou d'illustrations : selon la licence, les enseignants peuvent non seulement utiliser les ressources, mais aussi les adapter directement à leur classe. Cette vidéo explique précisément comment procéder.`
};

const de_oer_information_basics_text24 = /** @type {(inputs: {}) => string} */ () => {
	return `Ihre Unterrichtsvorbereitung ist in vollem Gange und das Lehrbuch veraltet?<bold> OER</bold> , oder<bold> Offene Bildungsressourcen</bold> im Web kann eine tolle Alternative sein. Ob Arbeitsblätter, Fotos oder Grafiken: Je nach Lizenz können Lehrkräfte die Materialien nicht nur nutzen, sondern auch direkt für ihren Unterricht anpassen. Wie das genau funktioniert, erklärt dieses Video.`
};

const es_oer_information_basics_text24 = /** @type {(inputs: {}) => string} */ () => {
	return `¿Está preparando su clase y el libro de texto está desactualizado? Los <bold>REA</bold>, o <bold>recursos educativos abiertos</bold>, en la web, pueden ser una gran alternativa. Ya sean hojas de trabajo, fotos o gráficos: según la licencia, los docentes no solo pueden usar los materiales, sino también adaptarlos directamente para su clase. Este video explica exactamente cómo funciona.`
};

const it_oer_information_basics_text24 = /** @type {(inputs: {}) => string} */ () => {
	return `La tua lezione è in corso e il libro di testo è obsoleto? OER, ovvero <bold>Open Educational Resources sul web, può essere un'ottima alternativa. Che si tratti di fogli di lavoro, foto o grafici: a seconda della licenza, gli insegnanti non solo possono utilizzare i materiali, ma anche adattarli direttamente per la loro classe. Questo video spiega esattamente come funziona.`
};

const ar_oer_information_basics_text24 = /** @type {(inputs: {}) => string} */ () => {
	return `هل تستعد لدرسك وقد عفا عليه الزمن؟ يمكن أن تكون الموارد التعليمية المفتوحة على شبكة الإنترنت بديلاً رائعًا. سواء كانت أوراق عمل أو صورًا أو رسومات بيانية: اعتمادًا على الترخيص، لا يستطيع المعلمون استخدام المواد فحسب، بل يمكنهم أيضًا تكييفها بشكل مباشر مع فصولهم الدراسية. يوضح هذا الفيديو بالضبط كيف يعمل ذلك.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const oer_information_basics_text24 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oer_information_basics_text24(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oer_information_basics_text24", locale)
	if (locale === "en") return en_oer_information_basics_text24(inputs)
	if (locale === "fr") return fr_oer_information_basics_text24(inputs)
	if (locale === "de") return de_oer_information_basics_text24(inputs)
	if (locale === "es") return es_oer_information_basics_text24(inputs)
	if (locale === "it") return it_oer_information_basics_text24(inputs)
	return ar_oer_information_basics_text24(inputs)
};
export { oer_information_basics_text24 as "OER_INFORMATION_BASICS_TEXT" }